import { Injectable,inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivateFn, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PagesAvailableService } from 'src/app/pages/pages-available.service';
import { UserBasicInfo, UserBasicService } from '../services/user-basic.service';


@Injectable({
  providedIn: 'root'
})
class PermissionsService {
  
  userInfo: UserBasicInfo;
  userBasicSub: Subscription;
  cashbackApproved: boolean;
  
  constructor(private readonly pagesService: PagesAvailableService,
    private readonly userBasicService: UserBasicService,
    private readonly route: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // TODO check if current page is allowed for client
   
    return true;
  }
}

export const PageAccessGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(PermissionsService).canActivate(next, state);
}
